var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoveIconFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.4,
    viewBox: "0 0 16 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "love-icon-fill",
    d: "M8.4,7A4.473,4.473,0,0,0,4,11.526c0,1.685,1.235,3.272,2.741,4.9S10.1,19.7,11.576,21.219a.588.588,0,0,0,.848,0c1.476-1.519,3.33-3.167,4.835-4.794S20,13.211,20,11.526A4.473,4.473,0,0,0,15.6,7,4.574,4.574,0,0,0,12,9.072,4.574,4.574,0,0,0,8.4,7Z",
    transform: "translate(-4 -7)",
    fill: "#325ae7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIconFill);
export default __webpack_public_path__ + "static/media/love-icon-fill.ec693568bcbe992090c3d0f9ff683f10.svg";
export { ForwardRef as ReactComponent };